
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import {
  NRAttachment,
  NRCandidate,
  NRProject,
  NRProjectCase,
  NRProjectShortVideoCase
} from "@/lib/model/NRXQ/candidate";
import NRProjectCaseEdit from "./nr-project-case-edit.vue";
import request from "@/lib/request/request";
import { NRClientType } from "@/lib/model/NRXQ/nr";
import gateway from "@/lib/request/gateway";

@Component({
  components: {}
})
export default class NRAttachmentEdit extends Vue {
  @Prop({
    type: NRCandidate,
    default: () => {
      return new NRCandidate();
    }
  })
  cv!: NRCandidate;
  @Prop() atsCvId!: any;
  @Prop({ default: false, type: Boolean }) isResultPage!: boolean; //是否是报告页展示
  @Prop({ type: String, default: NRClientType.NRClientTypeAdmin })
  clientType!: string;

  uploading = false;
  showDel = false;
  currentDeleteFile!: NRAttachment;
  upIndex = 0; //正在上传的是哪个框
  percent0 = 0;
  percent1 = 0;
  percent2 = 0;
  percent3 = 0;
  percent4 = 0;
  bar0 = false;
  bar1 = false;
  bar2 = false;
  bar3 = false;
  bar4 = false;
  showBigImg = false;
  bigImgUrl = "";
  isVideo = false;

  sectionList = [
    "案例数据截图",
    "策划类文件",
    "复盘文件",
    "管理执行文件",
    "学习文件"
  ];
  currentUploadSection = "";
  setBar(i: number) {
    this["bar" + i] = true;
  }
  showBar(i: number) {
    return this["bar" + i];
  }
  showPer(i: number) {
    return this["percent" + i];
  }

  created() {
    //
  }

  mounted() {
    //
  }

  openLink(link: string) {
    window.open(link);
  }

  attachmentList(type: string) {
    return this.cv.nrAttachmentList.filter((item: any) => {
      return item.fileType === type;
    });
  }
  //区分文件类型
  checkFileType(name: string) {
    if (
      ["PNG", "JPG", "png", "jpg", "bmp", "BMP"].includes(name.slice(-3)) ||
      ["JPEG", "jpeg"].includes(name.slice(-4))
    ) {
      return "img";
    } else if (
      ["rm", "RM"].includes(name.slice(-2)) ||
      [
        "mp4",
        "MP4",
        "avi",
        "AVI",
        "mov",
        "MOV",
        "flv",
        "FLV",
        "3gp",
        "3GP"
      ].includes(name.slice(-3)) ||
      ["rmvb", "RMVB"].includes(name.slice(-4))
    ) {
      return "video";
    } else {
      return "other";
    }
  }
  //打开文件
  openFile(type: string, url: string) {
    if (type === "img") {
      this.openImg(url);
    }
    if (type === "video") {
      this.openImg(url, "video");
    }
    if (type === "other") {
      this.openLink(url);
    }
  }
  //查看大图
  openImg(url: string, type = "") {
    this.isVideo = type === "video" ? true : false;
    this.bigImgUrl = url || "";
    this.showBigImg = true;
  }
}
